// eslint-disable-next-line no-restricted-imports -- This is the wrapper implementation
import { TableContainer, type TableContainerProps } from '@mui/material'
import type { RefObject } from 'react'
import { useScrollHint } from '~hooks/use-scroll-hint'

interface ScrollHintTableContainerProps extends TableContainerProps {
  containerRef?: RefObject<HTMLDivElement | null>
  scrollHintId?: string
  trigger?: boolean
}

export function ScrollHintTableContainer({
  containerRef,
  scrollHintId,
  trigger = true,
  ...props
}: ScrollHintTableContainerProps) {
  const ref = useScrollHint<HTMLDivElement>({
    trigger,
    id: scrollHintId,
    ref: containerRef,
  })

  return <TableContainer ref={ref} {...props} />
}
